import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './Menu';

const MenuSuspense = dynamic(() => import('./Menu'), {
	loading: () => <BlockLoadingSpinner size="small" />,
});

export default function DynamicMenu(props: Props) {
	return <MenuSuspense {...props} />;
}
DynamicMenu.displayName = 'DynamicMenu';
